import { post } from "../../utils/backend";
import { readConceptCatalogCache, writeConceptCatalogCache } from "./ConceptCatalogCache";
import { mockListConcepts, mockSearchConceptStocks } from "./ConceptMock";
import type {
  ConceptBrief,
  ConceptSearchParams,
  ConceptStockRow,
} from "./ConceptType";

/** 改为 `mock && false` 可走真实网关 */
export const mock = true && false;

const BASE = "/lark/app/concept";

function assertResult<T>(res: T | string): T {
  if (typeof res === "string") {
    throw new Error(res);
  }
  return res;
}

export const ConceptApi = {
  listConcepts: async (spaceProductId: string): Promise<ConceptBrief[]> => {
    const cached = readConceptCatalogCache(spaceProductId);
    if (cached) {
      return cached;
    }
    if (mock) {
      const list = await mockListConcepts();
      writeConceptCatalogCache(spaceProductId, list);
      return list;
    }
    const raw = await post<{ spaceProductId: string }, ConceptBrief[]>(
      `${BASE}/listConcepts`,
      { spaceProductId },
      { silent: true }
    );
    const list = assertResult(raw);
    writeConceptCatalogCache(spaceProductId, list);
    return list;
  },

  searchStocks: async (params: ConceptSearchParams): Promise<ConceptStockRow[]> => {
    if (mock) {
      return mockSearchConceptStocks(params);
    }
    const raw = await post<ConceptSearchParams, ConceptStockRow[]>(
      `${BASE}/searchStocks`,
      params,
      { silent: true }
    );
    return assertResult(raw);
  },
};
